import React from "react";
import { Grid, Divider, Chip } from "@mui/material";
import SoftBox from "components/SoftComponents/SoftBox";
import SoftTypography from "components/SoftComponents/SoftTypography";
import SoftInput from "components/SoftComponents/SoftInput";

// Helper to render error text
const ErrorMessage = ({ error }) => {
  if (!error) return null;
  return (
    <SoftTypography variant="caption" color="error" fontWeight="medium" sx={{ display: 'block', mt: 0.5 }}>
      {error.message}
    </SoftTypography>
  );
};

const PlannedNoticeForm = ({ register, errors, watch, setValue, preview = false, data = null }) => {
  // If in preview mode, we use the passed 'data' prop; otherwise, we watch the form state
  const currentValues = preview ? data : watch("formData");

  return (
    <SoftBox 
      p={preview ? 1.5 : 2} 
      sx={{ 
        border: preview ? '1px solid #ddd' : '1px dashed #ccc', 
        borderRadius: '8px', 
        backgroundColor: '#fff',
        height: preview ? 'fit-content' : 'auto',
        overflowY: preview ? 'auto' : 'visible'
      }}
    >

      {/* TITLE */}
      <SoftBox mb={preview ? 1 : 2}>
        <SoftBox pl={1} mb={0.5}>
          <SoftTypography variant={preview ? "caption" : "body3"} fontWeight="bold">Title</SoftTypography>
        </SoftBox>
        <SoftInput 
          placeholder="e.g., Line 86 Service Update" 
          {...(!preview ? register('formData.title', { required: "A Title is required" }) : { value: currentValues?.title || '', disabled: true })} 
          error={!preview && !!errors?.formData?.title}
          size={preview ? "small" : "medium"}
        />
        {!preview && <ErrorMessage error={errors?.formData?.title} />}
      </SoftBox>
      
      {/* DESCRIPTION */}
      <SoftBox mb={0}>
        <SoftBox pl={1} mb={0.5}>
          <SoftTypography variant={preview ? "caption" : "body3"} fontWeight="bold">Description</SoftTypography>
        </SoftBox>
        <SoftInput 
          placeholder="Provide more details here..." 
          multiline
          rows={preview ? 2 : 3}
          {...(!preview ? register('formData.text') : { value: currentValues?.text || '', disabled: true })} 
          error={!preview && !!errors?.formData?.text}
          size="small"
        />
        {!preview && <ErrorMessage error={errors?.formData?.text} />}
      </SoftBox>
    </SoftBox>
  );
};

export default PlannedNoticeForm;